import { Box } from 'braid-design-system';
import { OptionsBar } from '@seek/job-details-view';

import type { JobDetails } from 'src/store/jobdetails/jobdetails';
import { usePropsForJobDetailsView } from '../JobDetailsPage/usePropsForJobDetailsView';

export const OptionsBarView = ({ jobDetail }: { jobDetail: JobDetails }) => {
  const { job, jobUrlOpts, onAnalyticsEvent, renderRelativePaths } =
    usePropsForJobDetailsView(jobDetail);

  return (
    <Box
      display="flex"
      justifyContent="flexEnd"
      paddingY="large"
      // Make sure it will not block the above Search Refinement,
      // and it will correctly show the dropdown on top of the JDV
      zIndex={1}
      position="relative"
    >
      <OptionsBar
        job={job}
        jobUrlOpts={jobUrlOpts}
        renderRelativePaths={renderRelativePaths}
        onAnalyticsEvent={onAnalyticsEvent}
      />
    </Box>
  );
};
